import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'

import chinaWall from '../../assets/chinaWall.png'

import Content from '../../components/Content'
import Container from '../../components/Container'

class About extends Component {
  render() {
    const { pages = [] } = this.props
    const content =
      pages.find(({ path }) => path === window.location.pathname) || {}
    const { atemption = {} } = content

    return (
      <Container>
        <CustomRow>
          <Col md={6}>
            <Rectangle className="animated fadeInLeft fast">
              <img src={chinaWall} alt="" />
            </Rectangle>
          </Col>

          <Col
            style={{ position: 'relative' }}
            md={6}
            className="animated fadeInDown fast">
            <Content />

            <Atemption className="animated delay-1s fadeInRight">
              {atemption.html ? (
                <div class="content">{atemption.html}</div>
              ) : (
                <div class="content">
                  Мы работаем с ведущими дизайнерскими студиями для создания
                  уникальных проектов <br /> и максимально облегчаем процесс его
                  подготовки и запуска, предлагая эксклюзивный <br /> доступ к
                  проверенным производителям Китая.
                </div>
              )}
            </Atemption>
          </Col>
        </CustomRow>
      </Container>
    )
  }
}

export default connect(state => state)(About)

const Rectangle = styled.div`
  position: relative;
  margin-top: 10px;
  width: 100%;
  height: 70vh;
  background: linear-gradient(180deg, #2568e4 0%, #00233a 100%);
  margin-bottom: 50px;
  & img {
    width: 95%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`
const CustomRow = styled(Row)`
  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`

const Atemption = styled.div`
  background-color: #2568e4;
  width: 120%;
  border-radius: 10px;
  padding: 10px 15px;
  margin: 20px 15px;
  margin-left: -20%;
  /* display: none; */
  @media (max-width: 768px) {
    display: flex;
    width: calc(100% - 30px);
    margin: 20px 15px;
  }
  .content {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 28px;
    color: #fff;
    opacity: 0.7;
    transition: all 1s;
  }
`
